<template>
  <div class="main-box">
    <div style="position: relative">
      <el-tabs v-model="tabIdx" @tab-click="chooseTab">
        <el-tab-pane label="全部文档" name="0"></el-tab-pane>
        <el-tab-pane :label="item.title" :id="item.id" v-for="(item,index) in menuList" :key="index"></el-tab-pane>
      </el-tabs>
    </div>
    <el-table
        :data="tableData"
        ref="rfTable"
        style="width: 100%"
        size="mini"
        @selection-change="handleSelectionChange">
      <el-table-column
          prop="menu_title"
          label="类型"
          width="200">
      </el-table-column>
      <el-table-column
          prop="title"
          label="标题">
      </el-table-column>
      <el-table-column
          prop="ftime"
          label="添加时间"
          align="center"
          width="240">
      </el-table-column>
      <el-table-column
          fixed="right"
          label="操作"
          align="center"
          width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showConten(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40]"
        :total="search.total">
    </el-pagination>
    <el-dialog
        title="文档内容"
        :visible.sync="dialogVisible"
        width="60%">
      <div style="background-color: #fff">
        <div class="edit-box" v-html="checkItem.content"></div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  components: {
  },
  data() {
    return {
      dialogVisible: false,
      checkItem: false,
      tabIdx: '0',
      source_domain: this.config.SOURCE_DOMAIN,
      search: {
        current_page: 1,
        total: 0,
        limit: 10,
        keywords: '',
        pid: ''
      },
      tableData: [],
      menuList: []
    };
  },
  created() {
    this.getMenuList()
    this.getList();
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    chooseTab(e) {
      this.tabIdx = e.index
      if(e.index > 0) {
        this.search.pid = this.menuList[e.index-1].id
      } else {
        this.search.pid = ''
      }
      this.handleSearch()
    },
    getMenuList() {
      this.$api.merchant.helpMenu({},res=>{
        if(res.errcode == 0) {
          this.menuList = res.data
        }
      })
    },
    getList() {
      var that = this
      that.showLoading()
      var param = {
        page: that.search.current_page,
        page_size: that.search.limit,
        keywords: that.search.keywords,
        pid: that.search.pid
      }
      this.$api.merchant.helpIndex(param, res => {
        that.hideLoading()
        if(res.errcode == 0) {
          that.tableData = res.data.data
          that.search.current_page = res.data.current_page
          that.search.total = res.data.total
        } else {
          that.fail(res.errmsg)
        }
      })
    },
    showConten(item) {
      this.checkItem = item
      this.dialogVisible = true
    },
    handleSearch() {
      this.search.current_page = 1
      this.getList()
    },
    handleSelectionChange(rows) {
    },
    handleCurrentChange(val) {
      this.search.current_page = val
      this.getList()
    },
    handleSizeChange(val) {
      this.search.current_page = 1
      this.search.limit = val
      this.getList()
    }
  }
};
</script>
<style scoped>
</style>
